// @ts-check
import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core'; // eslint-disable-line no-unused-vars
import { FAIcon } from 'preferral-ui/components/FAIcon';

const colorClassNames = {
  gray: 'bg-gray-200 text-gray-700',
  red: 'bg-red-200 text-red-700',
  orange: 'bg-orange-200 text-orange-700',
  yellow: 'bg-yellow-200 text-yellow-700',
  green: 'bg-green-200 text-green-700',
  teal: 'bg-teal-200 text-teal-700',
  blue: 'bg-blue-200 text-blue-700',
  indigo: 'bg-indigo-200 text-indigo-700',
  purple: 'bg-purple-200 text-purple-700',
  pink: 'bg-pink-200 text-pink-700',
  gold: 'bg-gold-200 text-gold-700',
  navy: 'bg-navy-200 text-navy-700',
};

/** @typedef {{
  icon: IconProp;
  size?: number;
  iconSize?: number;
  color?: string;
  className?: string;
}} CircleIconProps */

/** @type { React.FC<CircleIconProps> } */
export const CircleIcon = ({
  icon,
  size,
  iconSize,
  color = 'blue',
  className = '',
}) => {
  return (
    <div
      className={`${colorClassNames[color]} h-10 w-10 flex justify-center items-center rounded-full ${className}`}
      style={!!size ? { width: size, height: size } : {}}
    >
      {!!iconSize ? (
        <span style={{ fontSize: iconSize }}>
          <FAIcon icon={icon} />
        </span>
      ) : (
        <FAIcon icon={icon} />
      )}
    </div>
  );
};
